import React from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'greenPrimary' | 'greenAccent';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const base = 'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none px-4 py-2';

const variantClass: Record<ButtonVariant, string> = {
  primary: 'bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-emerald-600',
  secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-200 focus:ring-slate-400',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-600',
  ghost: 'bg-transparent text-slate-900 hover:bg-slate-100 focus:ring-slate-400',
  greenPrimary: 'btn-green-primary',
  greenAccent: 'btn-green-accent',
};

// forwardRef so dialogs can move focus onto their primary action on mount
// (a11y: the guest wall and future modals focus their main button).
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', className, ...props }, ref) => {
    return (
      <button ref={ref} className={twMerge(clsx(base, variantClass[variant], className))} {...props} />
    );
  }
);
Button.displayName = 'Button';

export default Button;
